<template>
  <div>
    <b-modal
      id="download-rincian-saldo"
      size="md"
      centered
      hide-header
      hide-footer
      body-class="!p-6 !overflow-visible"
      content-class="!rounded-[4px] !overflow-visible"
      dialog-class="!overflow-visible"
      @show="onModalShow"
    >
      <div class="text-[#222222] font-bold text-[20px] md:text-[22px] mb-1">
        Download Rincian Saldo
      </div>
      <div class="text-[#686868] text-[14px] md:text-[15px] mb-2 leading-normal">
        Kustomisasi rincian saldo yang ingin kamu download
      </div>
      <div class="text-[#222222] font-medium text-[14px] mb-1.5">
        Pilih Rentang
      </div>
      <div>
        <date-range-picker
          ref="picker"
          v-model="dateRangeDownload"
          :locale-data="locale"
          :ranges="rangesDownload"
          :max-date="today"
          :opens="'center'"
          class="w-100"
          control-container-class="w-full flex items-center border border-[#E2E2E2] rounded-[8px] px-1 py-[8px] bg-white cursor-pointer"
        >
          <template v-slot:input="picker">
            <div class="flex items-center text-[#222222]">
              <img
                src="https://storage.googleapis.com/komerce/assets/icons/date-picker-icon.svg"
                alt="Calendar"
                class="w-5 h-5 mr-1 object-contain"
              >
              <span class="text-[14px] text-[#222222] font-normal">
                {{ formatDateRange(picker) }}
              </span>
            </div>
          </template>
        </date-range-picker>
        <small
          v-if="isExceedMaxDays"
          class="text-danger d-block mt-1"
        >
          Maksimal rentang tanggal adalah 60 hari
        </small>
      </div>

      <!-- Checkbox Filters (KomPay & KomPoints) -->
      <div class="flex items-center gap-6 mt-2">
        <!-- KomPay Checkbox -->
        <div
          class="flex items-center select-none"
          :class="isKompay && !isKompoints ? 'cursor-default' : 'cursor-pointer'"
          @click="toggleCheckbox('kompay')"
        >
          <div
            class="w-[18px] h-[18px] rounded-[4px] flex items-center justify-center transition-colors"
            :class="isKompay ? 'bg-[#F95031] border border-[#F95031]' : 'border border-[#D1D5DB] bg-white'"
          >
            <svg
              v-if="isKompay"
              class="w-3 h-3 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <span class="ml-2 text-[14px] font-medium text-black">
            KomPay
          </span>
        </div>

        <!-- KomPoints Checkbox -->
        <div
          class="flex items-center select-none"
          :class="isKompoints && !isKompay ? 'cursor-default' : 'cursor-pointer'"
          @click="toggleCheckbox('kompoints')"
        >
          <div
            class="w-[18px] h-[18px] rounded-[4px] flex items-center justify-center transition-colors"
            :class="isKompoints ? 'bg-[#F95031] border border-[#F95031]' : 'border border-[#D1D5DB] bg-white'"
          >
            <svg
              v-if="isKompoints"
              class="w-3 h-3 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <span class="ml-2 text-[14px] font-medium text-black">
            KomPoints
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex items-center gap-3 mt-2">
        <div class="w-1/2">
          <b-button
            variant="outline-primary"
            block
            class="!rounded-[8px] !h-[42px] font-semibold text-[14px] flex items-center justify-center"
            @click="closeModal"
          >
            Batal
          </b-button>
        </div>
        <div class="w-1/2">
          <b-button
            variant="primary"
            block
            class="!rounded-[8px] !h-[42px] font-semibold text-[14px] flex items-center justify-center"
            :disabled="isExceedMaxDays || downloadStatus === 'loading'"
            @click="downloadDetailSaldo"
          >
            <b-spinner
              v-if="downloadStatus === 'loading'"
              class="mr-1"
              small
              variant="light"
            />
            Download
          </b-button>
        </div>
      </div>
    </b-modal>

    <ModalStatusDownload
      :status="downloadStatus"
      @on-action="handleModalAction"
    />
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
  today,
  last7,
  last30,
  last60,
  kompackDate,
} from '@/store/helpers'
import { YEAR_MONTH_DAY, SLASH_DATE } from '@/libs/formatDate'

import ModalStatusDownload from './ModalStatusDownload.vue'

export default {
  name: 'DownloadRincianSaldo',
  components: {
    DateRangePicker,
    ModalStatusDownload,
  },
  data() {
    return {
      downloadStatus: '',
      isKompay: true,
      isKompoints: true,
      dateRangeDownload: {
        startDate: today,
        endDate: today,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
      },
      rangesDownload: {
        'Hari Ini': [today, today],
        '7 Hari Terakhir': [last7, today],
        '30 Hari Terakhir': [last30, today],
        'Custom Tanggal': [null, null],
      },
      today,
      last7,
      last30,
      last60,
      kompackDate,
    }
  },
  computed: {
    isExceedMaxDays() {
      if (!this.dateRangeDownload?.startDate || !this.dateRangeDownload?.endDate) return false
      const start = new Date(this.dateRangeDownload.startDate)
      const end = new Date(this.dateRangeDownload.endDate)
      const diffTime = Math.abs(end - start)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays > 60
    },
  },
  methods: {
    onModalShow() {
      this.resetFilterState()
    },
    resetFilterState() {
      this.isKompay = true
      this.isKompoints = true
    },
    toggleCheckbox(type) {
      if (type === 'kompay') {
        if (this.isKompay && !this.isKompoints) {
          // Safeguard: Minimum 1 active, cannot uncheck the last checked option
          return
        }
        this.isKompay = !this.isKompay
      } else if (type === 'kompoints') {
        if (this.isKompoints && !this.isKompay) {
          // Safeguard: Minimum 1 active, cannot uncheck the last checked option
          return
        }
        this.isKompoints = !this.isKompoints
      }
    },
    formatDateRange(picker) {
      const start = picker?.startDate || this.dateRangeDownload?.startDate
      const end = picker?.endDate || this.dateRangeDownload?.endDate
      if (!start || !end) return ''
      return `${SLASH_DATE(start)} - ${SLASH_DATE(end)}`
    },
    closeModal() {
      this.$bvModal.hide('download-rincian-saldo')
      this.resetFilterState()
    },
    handleModalAction() {
      this.$bvModal.hide('modal-status-download')
    },
    saveBase64File(base64) {
      const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0))
      const blob = new Blob([bytes], { type: 'application/vnd.ms-excel' })
      const url = URL.createObjectURL(blob)
      const a = Object.assign(document.createElement('a'), {
        href: url,
        download: `Rincian_Saldo_Partner_${YEAR_MONTH_DAY(this.dateRangeDownload.startDate)}_${YEAR_MONTH_DAY(this.dateRangeDownload.endDate)}.xlsx`,
      })
      a.click()
      URL.revokeObjectURL(url)
    },
    downloadDetailSaldo() {
      if (this.isExceedMaxDays) return

      let category = 'all'
      if (this.isKompay && this.isKompoints) {
        category = 'all'
      } else if (this.isKompay) {
        category = 'kompay'
      } else if (this.isKompoints) {
        category = 'kompoints'
      }

      const params = {
        start_date: YEAR_MONTH_DAY(this.dateRangeDownload.startDate),
        end_date: YEAR_MONTH_DAY(this.dateRangeDownload.endDate),
        category,
      }

      this.closeModal()
      this.downloadStatus = 'loading'
      this.$bvModal.show('modal-status-download')

      this.$http_new
        .get('/auth/api/v1/partner/print/transaction-balance', {
          params,
        })
        .then(response => {
          const { data, code = 200 } = response.data || {}

          if (code === 422) {
            this.downloadStatus = 'queue'
          } else if (code !== 200) {
            this.downloadStatus = 'error'
          } else if (typeof data === 'string' && data) {
            this.saveBase64File(data)
            this.downloadStatus = 'device'
          } else if (Array.isArray(data)) {
            this.downloadStatus = 'empty'
          } else if (data == null) {
            this.downloadStatus = 'email'
          } else {
            this.downloadStatus = 'error'
          }
        })
        .catch(err => {
          const status = err.response?.status || err.response?.data?.code
          this.downloadStatus = status === 422 ? 'queue' : 'error'
        })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .vue-daterangepicker {
  width: 100% !important;

  .reportrange-text {
    display: flex !important;
    align-items: center !important;
    border: 1px solid #E2E2E2 !important;
    border-radius: 8px !important;
    padding: 10px 14px !important;
    height: auto !important;
    min-height: 44px !important;
    background: #ffffff !important;
    cursor: pointer !important;
  }
}
</style>

<style lang="scss">
#download-rincian-saldo {
  overflow-x: visible !important;

  .modal-dialog {
    overflow: visible !important;
  }

  .modal-content {
    overflow: visible !important;
    border-radius: 8px !important;
  }

  .modal-body {
    overflow: visible !important;
  }

  .vue-daterangepicker {
    .daterangepicker {
      z-index: 9999 !important;
    }
  }
}
</style>
